/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import { CustomTextClassStore } from 'src/customText/core/stores/CustomTextClassStore';
import { CustomTextEntityLabelStore } from 'src/customText/core/stores/CustomTextEntityLabelStore';

export type GptEntityLabel = CustomTextEntityLabelStore & { labelId: string };
export type GptPredictedDocumentData = OmitFunctions<CustomTextGptPredictedDocument>;

export class CustomTextGptPredictedDocument {
    public name: string;

    @observable public entityLabels: GptEntityLabel[];

    @observable public classLabels: CustomTextClassStore[];

    @observable public acceptedEntityLabels: GptEntityLabel[];

    @observable public rejectedEntityLabels: GptEntityLabel[];

    @observable public acceptedClassLabels: CustomTextClassStore[];

    @observable public rejectedClassLabels: CustomTextClassStore[];

    constructor(documentData: Partial<GptPredictedDocumentData>) {
        this.name = documentData.name;
        this.classLabels = documentData.classLabels ?? [];
        this.entityLabels = documentData.entityLabels ?? [];
        this.acceptedClassLabels = documentData.acceptedClassLabels ?? [];
        this.rejectedClassLabels = documentData.rejectedClassLabels ?? [];
        this.acceptedEntityLabels = documentData.acceptedEntityLabels ?? [];
        this.rejectedEntityLabels = documentData.rejectedEntityLabels ?? [];
    }

    @action
    public setEntityLabels(entities: GptEntityLabel[]) {
        this.entityLabels = entities;
    }

    @action
    public setAcceptedEntityLabels(entities: GptEntityLabel[]) {
        this.acceptedEntityLabels = entities;
    }

    @action
    public setRejectedEntityLabels(entities: GptEntityLabel[]) {
        this.rejectedEntityLabels = entities;
    }

    @action
    public setClassLabels(classes: CustomTextClassStore[]) {
        this.classLabels = classes;
    }

    @action
    public setAcceptedClassLabels(classes: CustomTextClassStore[]) {
        this.acceptedClassLabels = classes;
    }

    @action
    public setRejectedClassLabels(classes: CustomTextClassStore[]) {
        this.rejectedClassLabels = classes;
    }
}
